"use strict";
/**
 * Inventory Report Requests
 *
 * Request types for inventory report generation.
 *
 * @example POST /api/inventory/reports/generate
 * @example GET /api/inventory/reports/periods
 */
Object.defineProperty(exports, "__esModule", { value: true });
